import { ROUTES_PATH } from './routesPath'

export const URL_DOWNLOAD_IOS = 'https://apps.apple.com/br/app/nav/id1553834596'
export const URL_DOWNLOAD_ANDROID = 'https://play.google.com/store/apps/details?id=br.com.nav'
export const LIBERATED_ROUTES = [ROUTES_PATH.RECOVER_PASSWORD]
